// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  letterId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ letterId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/letters/${letterId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  letterId: string,
};

export const readComments = ({ letterId }: ReadCommentsPayload) =>
  axios.get(`/letters/${letterId}/comments`);

export type ReadSubCommentsPayload = {
  letterId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ letterId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/letters/${letterId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  letterId: string,
  commentId: string,
};

export const removeComment = ({ letterId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/letters/${letterId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  letterId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ letterId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/letters/${letterId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/letters/comments.js